import type { Locale } from "date-fns"
import { de, ja } from "date-fns/locale"

/**
 * Format an ISO 8601 UTC timestamp as `DD.MM.YYYY` (EU style). Accepts a Date too,
 * since apiClientV2 revives createdAt/updatedAt response keys into Date instances.
 * Returns "" for null / undefined / unparseable input so callers can treat the
 * result as falsy and skip rendering.
 */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return ""
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return ""
  const dd = String(date.getUTCDate()).padStart(2, "0")
  const mm = String(date.getUTCMonth() + 1).padStart(2, "0")
  const yyyy = date.getUTCFullYear()
  return `${dd}.${mm}.${yyyy}`
}

/** BCP-47 tag for Intl APIs (toLocaleDateString etc.) from the app language
 *  (useTranslation currentLanguage: "EN" | "DE" | "JA"). */
export function intlLocale(language: string): string {
  if (language === "DE") return "de-DE"
  if (language === "JA") return "ja-JP"
  return "en-US"
}

/** date-fns locale for the app language; undefined = date-fns' en-US default. */
export function dateFnsLocale(language: string): Locale | undefined {
  if (language === "DE") return de
  if (language === "JA") return ja
  return undefined
}
